import { ReactNode, useMemo } from 'react';
import { Alert } from '@optiaxiom/react';

import { TurnstileInstance } from '@frontend/api/types';
import FullScreenLoader from '@frontend/components/FullScreenLoader';
import { useOpalUser } from '@frontend/hooks';

import { ConnectionContextType, transformConnectionsToProducts } from './connectionUtils';

type ConnectionGetter = {
  connections: TurnstileInstance[];
  isPending: boolean;
  error: Error | null;
};

type BaseConnectionProviderProps = {
  children: ReactNode;
  connectionGetter: ConnectionGetter;
  context: React.Context<ConnectionContextType>;
};

export const BaseConnectionProvider = ({
  children,
  connectionGetter,
  context,
}: BaseConnectionProviderProps) => {
  const { opalUser } = useOpalUser();

  const products = useMemo(() => {
    return transformConnectionsToProducts(
      connectionGetter.connections,
      opalUser.instance.instance_id
    );
  }, [connectionGetter.connections, opalUser.instance.instance_id]);

  if (connectionGetter.isPending) {
    return <FullScreenLoader />;
  }

  if (connectionGetter.error) {
    return <Alert intent="danger">Failed to fetch connections</Alert>;
  }

  const ContextProvider = context.Provider;

  return <ContextProvider value={{ products }}>{children}</ContextProvider>;
};
